export type MCPQueryScope = {
  principalId: string | null;
  workspace: { kind: "personal" } | { kind: "organization"; id: string };
  projects: { kind: "all" } | { kind: "selected"; ids: string[] };
};

export const MCP_CONNECTIONS_QUERY_KEY = ["mcp-connections"] as const;

export const mcpQueryKeys = {
  scope: (scope: MCPQueryScope) => [
    ...MCP_CONNECTIONS_QUERY_KEY,
    {
      principalId: scope.principalId,
      workspace: scope.workspace,
      // TanStack prefix filters partially match nested arrays. Encode the
      // complete selection atomically so [a] cannot match [a, b] during writes.
      projects: scope.projects.kind === "all"
        ? { kind: "all" as const }
        : { kind: "selected" as const, ids: JSON.stringify(scope.projects.ids) },
    },
  ] as const,
  lists: (scope: MCPQueryScope) => [...mcpQueryKeys.scope(scope), "list"] as const,
  list: (scope: MCPQueryScope, page: number, pageSize: number) =>
    [...mcpQueryKeys.lists(scope), page, pageSize] as const,
  detail: (scope: MCPQueryScope, id: string | null) =>
    [...mcpQueryKeys.scope(scope), "detail", id] as const,
  tools: (scope: MCPQueryScope, id: string | null) =>
    [...mcpQueryKeys.scope(scope), "tools", id] as const,
  test: (scope: MCPQueryScope, id: string | null) =>
    [...mcpQueryKeys.scope(scope), "test", id] as const,
};
